// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

/**
 * bbox
 * @param map
 * @returns {number[]} leftTopLat,leftTopLng,rightBotLat,rightBotLng
 */
export function getBoundingBoxParams (map) {
  const bound = map.getBounds()
  const leftBottom = bound.getSouthWest()
  const rightTop = bound.getNorthEast()
  return [leftBottom.lat, leftBottom.lng, rightTop.lat, rightTop.lng]
}

/**
 * calculate polygon bounding box
 * @param {number[][]} polygon
 * @returns {number[][]} [ [minlng, minlat], [maxlng, maxlat] ]
 */
export function getPolygonBBox (polygon) {
  let minlat
  let minlng
  let maxlat
  let maxlng

  for (let i = 0; i < polygon.length; i++) {
    if (i === 0) {
      minlat = polygon[i][1]
      minlng = polygon[i][0]
      maxlat = polygon[i][1]
      maxlng = polygon[i][0]
      continue
    }
    if (polygon[i][1] < minlat) {
      minlat = polygon[i][1]
    }
    if (polygon[i][1] > maxlat) {
      maxlat = polygon[i][1]
    }
    if (polygon[i][0] < minlng) {
      minlng = polygon[i][0]
    }
    if (polygon[i][0] > maxlng) {
      maxlng = polygon[i][0]
    }
  }
  return [
    [minlng, minlat],
    [maxlng, maxlat]
  ]
}
